<div
  class="product-type-criterium-selector"
  [ngClass]="
    selectedTypeOptions != null && selectedTypeOptions.length > 0
      ? 'type-selected'
      : ''
  "
>
  <mat-form-field appearance="outline">
    <mat-select
      matInput
      multiple
      placeholder="Producttype"
      [(ngModel)]="selectedTypeOptions"
      (ngModelChange)="selectedTypeOptionsChange()"
      name="productTypeCriteriumSelector"
      [compareWith]="compareTypeOptions"
    >
      <mat-option *ngFor="let option of typeOptions" [value]="option.value">{{
        option.label
      }}</mat-option>
    </mat-select>
  </mat-form-field>
</div>
